import React from 'react'

import LoadingDots from '@/shared/components/LoadingDots/LoadingDots'
import { useAppSelector } from '@/shared/store'
import { styled } from '@mui/material'

export type GlobalLoaderProps = {
  //
}

export const GlobalLoader: React.FC<GlobalLoaderProps> = () => {
  const loading = useAppSelector(state => state.userInterface.isGlobalLoading)

  return (
    <Backdrop $open={loading}>
      <LoadingDots secondary size={16}/>
    </Backdrop>
  )
}

export const Backdrop = styled('div', {
  shouldForwardProp: (prop) => prop !== '$open',
})<{ $open: boolean }>`
  display: ${({ $open }) => ($open ? 'flex' : 'none')};
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: ${({ theme }) => theme.zIndex.modal + 100};
  transition: opacity 0.3s;
  opacity: ${({ $open }) => ($open ? 1 : 0)};
  pointer-events: ${({ $open }) => ($open ? 'auto' : 'none')};
`